export default __webpack_public_path__ + "static/media/WCHSS_full-paper-template.2d2607a5.zip";